import { render, staticRenderFns } from "./OAuthGrant.vue?vue&type=template&id=7cba718a&scoped=true&"
import script from "./OAuthGrant.vue?vue&type=script&lang=js&"
export * from "./OAuthGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cba718a",
  null
  
)

export default component.exports